import { render } from "./NoteStrategy.vue?vue&type=template&id=478808fa&scoped=true&ts=true"
import script from "./NoteStrategy.vue?vue&type=script&lang=ts"
export * from "./NoteStrategy.vue?vue&type=script&lang=ts"

import "./NoteStrategy.vue?vue&type=style&index=0&id=478808fa&scoped=true&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478808fa"]])

export default __exports__